var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaskell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_70_924",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_70_924",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAAsSAAALEgHS3X78AAACo0lEQVR42u3crYtUURgH4FEYNVhEULYoiNa1rGgS4c5lDWbBP8CszaIw6fqRBbNZ2CqYxG5zNRkMlnWLwSB+voMbZDhT9sz92DnPA2+ZcJjhHH6/uXNnZjQCAAAAAAAAAAAAAAAAAAAAoAyTyWQj5nvMr33OdsyxuTUPx7zOWHM2N+xOd4fgYcyfjHmSWPNCzLeMNT/HnLA73RyAozHvMjbrZ8yVxLp3Mg/Wc7vT3SG4FPMjY7M+zFdBXdezKniTeQhUgSpQBaoAVWB3VIEqUAUclCp4rwpUwWNVoApUgSpQBapAFagCVaAKVIEqUAWqQBWogv/XrKqqlSqIx47EXBvQnFMFHVbBdDqdrbuV+VyXOY0q6LgK4rHTMbsOQNlVcMsBUAVbDoAq2HUAVIEDoAocAFXgAKgCB0AVOAAtVMF2ZhVcTqx7t6UquNfxXHWvYEBVgNvGtHQAct9kvUyseTzmk9vGw9/8UzE7GZv0NeZMYt2nS3ojpgpaPgAvMjfodmLN2b3030s6AMkqiMdOxlxsedZWffNvZm7Oq7quDyWi/+OSL8cWXRV8cRm4utE/hA+IGtHfX/QP4QOiRvT3G/193ytoRH//0d9nFTSiv//o77MKGtE/jOjvqwoa0T+c6O+jChrRP5zo76MKGtHfXvTP/u/42cCroBH97UX/g70/qW7jG0R1zKMlzKbobyf631ZVNd5b67zbxuVF//rcmn5tXFL0J9b0DaLSoj+xtiooLfoTz1sVlBT9qkD0qwLRrwqKj35VsMLRHzPe5+tRBaVFvyooPPpVgehPvT4/MSst+lVB4dE/z6+NC4x+VSD6VcEBi/77bb92VfBvo87GXM+Y9QWXW5uZ6447ev1rmc9zYwQAAAAAAAAAAAAAAAAAALDQXyWin4ktTe7TAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaskell);
export default __webpack_public_path__ + "static/media/haskell.3b175c7d8ede9f54f409e043a774f3ea.svg";
export { ForwardRef as ReactComponent };